import { css, htmlArray } from "../helpers/webComponents";
import { GameEventService } from "../services/GameEventService";
import { Page } from "../enums/Page";
import { GameLevelRouteService, LevelProgressResponse } from "../services/gameLevelRouteService";

/** CSS for the StartupComponent */
const styles: string = css`
    :host {
        display: flex;
        flex-direction: column;
        justify-content: space-between; /* Titel bovenaan, button onder */
        align-items: center;
        height: 100vh;
        width: 100%;
        font-family: "Onesize";
        background-image: url("/assets/img/startup_img.png");
        background-size: cover;
        background-position: center;
        color: white;
        text-align: center;
        padding: 20px; /* ruimte rond de content */
        box-sizing: border-box;
    }

    h1 {
        font-size: 3rem;
        /* helemaal bovenaan */
        margin: 0;
    }

    .button-container {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        flex-grow: 1;
        gap: 20px;
    }

    .button {
        background-image: url("/assets/img/ui/button_gray.png");
        background-size: 100% 100%;
        background-position: center;
        background-repeat: no-repeat;
        padding: 15px 30px;
        font-size: 1.5rem;
        border-radius: 8px;
        cursor: pointer;
        text-transform: uppercase;
        transition: 0.2s ease;
    }

    .button:hover {
        background-image: url("/assets/img/ui/button_gray_hover.png");
        background-size: 100% 100%;
        background-position: center;
        background-repeat: no-repeat;
        transform: scale(1.05);
    }

    .credits {
        position: absolute;
        top: 0;
        left: 0;
        font-size: 1rem;
        color: rgba(255, 255, 255, 0.7);
    }
    @media (max-width: 400px) {
        .credits {
            font-size: 0.8rem;
        }
        .button {
            font-size: 1.2rem;
        }
    }
`;

export class StartupComponent extends HTMLElement {
    private readonly _gameEventService: GameEventService = new GameEventService();
    private readonly _levelRouteService: GameLevelRouteService = new GameLevelRouteService();

    public connectedCallback(): void {
        this.attachShadow({ mode: "open" });
        this.render();
    }

    private render(): void {
        if (!this.shadowRoot) {
            return;
        }

        const elements: HTMLElement[] = htmlArray`
        <style>${styles}</style>

        <h1>Tower of Escape</h1>

        <div class="button-container">
            <div class="button" id="startButton">Start Game</div>
            <div class="button" id="levelButton">Select Level</div>
        </div>

        <div class="credits">© 2026 PB3-SE101 - Team 2</div>
    `;

        // Clear old content
        while (this.shadowRoot.firstChild) {
            this.shadowRoot.firstChild.remove();
        }

        this.shadowRoot.append(...elements);

        // Event listeners
        this.shadowRoot.getElementById("startButton")
            ?.addEventListener("click", () => {
                void this.startGame();
            });

        // **Toevoegen van LevelSelector switch**
        this.shadowRoot.getElementById("levelButton")?.addEventListener("click", () => {
            this._gameEventService.switchPage(Page.LevelSelector);
        });
    }

    private async startGame(): Promise<void> {
        try {
            const levelData: LevelProgressResponse = await this._levelRouteService.getLevels();

            // Trigger intro alleen als alleen 'startup' unlocked is en geen levels completed
            if (
                levelData.completed.length === 0 &&
                levelData.unlocked.length === 1 &&
                levelData.unlocked[0] === "startup"
            ) {
                this._gameEventService.switchPage(Page.Introduction);

                return;
            }

            // Anders direct naar de game
            this._gameEventService.switchPage(Page.Canvas);
        }
        catch (error) {
            console.error("Failed to load level data:", error);
        }
    }
}

window.customElements.define("startup-screen", StartupComponent);
